module.exports = __webpack_public_path__ + "img/UNIFORM PURPLE.ea860a2.svg";